export default {
    beforeCreate() { // Must before watch
        this.serviceInjectMixin_services = new Set();
    },
    beforeDestroy() {
        this.serviceInjectMixin_services.forEach(function(service) {
            if (service && service.destroy) {
                service.destroy();
            }
        });
    },
};
